<template>
  <v-container
  v-if="isDataReady"
  fluid>
    <section-title-with-request-id
    :request-id="remoteSupportProp.requestId"
    :title="$t(`pages.remoteSupport.${$parent.isRepairStatus(['WAITING_COMPLETION']) ? 'repairWaitingCompletion' : 'repairCompleted'}`)"/>
      <v-row
      v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SERVICE'])">
        <v-col>
           <p
            class="process-repair-tab-section-title mt-5"
            style="font-size: 20px; position: relative; top: 20px;">
              {{$t("pages.remoteSupport.totalDurationInHours", {hours: getTotalHours})}}
            </p>
            <p
            class="process-repair-tab-section-title mt-5"
            style="font-size: 20px; position: relative; top: 20px;">
              {{getLastSessionDate ? $t("pages.remoteSupport.lastSessionDate", {date: getLastSessionDate}) : $t("pages.remoteSupport.lastSessionDateNotSpecified")}}
            </p>
        </v-col>
      </v-row>
    <v-row
    v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SERVICE'])"
    dense 
    class="my-10">
      <v-col class="d-flex justify-center align-center">
        <process-repair-quick-btns
        ref="quickBtnsRef"
        :config="getQuickBtnsConfig"
        :loading.sync="isLoading"
        on-success-repair-status-message="dialogs.messages.success.completeRemoteSupportRequest"/>
      </v-col>
    </v-row>
    <p
    v-if="$parent.isRepairStatus(['WAITING_COMPLETION']) && $parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SERVICE'])"
    class="text-center font-weight-bold">
      {{$t("pages.remoteSupport.remindUserBeforeCompleteRequest")}}
    </p>
  </v-container>
</template>
<script>
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
import DateUtil from '@/utils/DateUtil'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
// import { compareObjects } from '@/utils/StringUtil'
export default {
  name: 'WaitingCompletionTabRemoteSupport',
  components: {
    ProcessRepairQuickBtns,
    SectionTitleWithRequestId
  },
  data() {
    return {
      isFormValid: false,
      isLoading: false,
      newData: null,
      isDataReady: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  methods: {
    openConfirmDialog() {
      this.$confirmActionDialog.open(
      'dialogs.titles.completeRemoteSupportRequest', 
      "dialogs.subtitles.aboutToCompleteRemoteSupportRequest", 
      'btns.complete',
      null,
      async () => await this.$refs.quickBtnsRef.tryToUpdateEntityStatus())
    },
    setChangedDialogItems() {
      this.tryToSaveData()  
      // NOTE: ENABLE_CHANGE_DIALOG - Enable this code, if changes dialog is needed.
      //-----------------------------------------------------------------
      // const old = this.remoteSupportProp.serviceReview
      // const _new = this.newData
      // const props = [
      //   {
      //     field: 'textFields.summary',
      //     prop: 'summary'
      //   }
      // ]

      // this.$changesDialog.open(
      //   'dialogs.titles.changes',
      //   compareObjects(old, _new, props),
      //   this.tryToSaveData,
      //   false
      // )
      //-----------------------------------------------------------------
    },
  },
  computed: {
    remoteSupportProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    getTotalHours() {
      let total = 0

      for (const { durationInHours } of this.remoteSupportProp.serviceReviewSessions) {
        total += durationInHours
      }

      return total
    },
    getLastSessionDate() {
      const lastIndex = this.remoteSupportProp.serviceReviewSessions.length - 1
      const LAST_SESSION = this.remoteSupportProp.serviceReviewSessions[lastIndex]

      return LAST_SESSION && LAST_SESSION.completionDate ? DateUtil.getDateNewYorkFormat(LAST_SESSION.completionDate) : null
    },
    getQuickBtnsConfig() {
      const btns = []

      btns.push({
        name: 'Complete',
        props: {
          'disabled': this.disabled || this.$parent.isNotRole(['ADMIN', 'SUPER_ADMIN', 'SERVICE']) || !this.newData.isAllowedToContinue
        },
        events: {
          click: () => this.openConfirmDialog()
        }
      })
      return btns
    }
  },
  mounted() {
    this.newData = {
      isAllowedToContinue: this.remoteSupportProp.isAllowedToContinue
    }
    this.isDataReady = true
  }
}
</script>
<style>

</style>